import { defineWave } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   HARCÈLEMENT — vitrine des menaces à CONDUITE.

   Une vague de démonstration pour les quatre archétypes à comportement de
   projectile (Harceleur, Tourbillon, Sabreur, Fauche). Chacun est introduit
   SEUL puis laissé respirer, dans l'ordre de leur difficulté de lecture — la
   même discipline que le monde 1 impose à l'Éclat avant le Faucheur : une leçon
   donnée au milieu du bruit n'est pas une leçon.

   ⚠️ Elle n'est volontairement câblée dans AUCUN niveau de la campagne. Le
   câblage d'un monde touche l'équilibrage (courbe de puissance, respirations,
   silence d'avant-boss) et relève du propriétaire du contenu de campagne, pas de
   l'ajout de ces archétypes. La vague existe pour montrer que la chaîne
   registre → levelSystem → pool → conduite tient de bout en bout ; on la dépose
   dans un niveau le jour où l'on compose le monde qui les emploie.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineWave({
  id: 'harcelement',
  duration: 24,
  spawns: [
    // 1. Fauche — la trajectoire angulaire, la plus douce des quatre leçons :
    //    on lit un rythme, on n'esquive presque rien.
    { at: 0.5, enemy: 'fauche', lane: 1, count: 2, spacing: 1.2 },
    { at: 3.5, enemy: 'fauche', lane: 5, count: 2, spacing: 1.2 },

    // 2. Tourbillon — la spirale : anticiper l'arc d'une balle. Ancré, seul,
    //    au centre : on a tout le temps de lire l'enroulement.
    { at: 7.0, enemy: 'tourbillon', lane: 3, count: 1, spacing: 0 },

    // 3. Harceleur — le missile guidé : l'esquive tardive. Deux, décalés, pour
    //    que la double poursuite oblige à casser sa course au bon moment.
    { at: 12.0, enemy: 'harceleur', lane: 2, count: 1, spacing: 0 },
    { at: 13.0, enemy: 'harceleur', lane: 4, count: 1, spacing: 0 },

    // 4. Sabreur — le faisceau balayant : trouver le côté déjà passé. En
    //    dernier, car c'est la lecture spatiale la plus exigeante.
    { at: 18.0, enemy: 'sabreur', lane: 3, count: 1, spacing: 0 },
  ],
});
